import React, { useContext } from "react";
import useViewport from "@hooks/useViewport";
import { ApplicationContext } from "@context/ApplicationContext";
import PlayIcon from "@components/Icons/PlayIcon";
import TrailerButton from "@components/TrailerButton";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const TopBanner = () => {
    const { topBanner, isLoadingTopBanner } = useContext(ApplicationContext);
    const { width } = useViewport();
    const tabletBreakpoint = 768;
    const desktopBreakpoint = 1220;

    if (isLoadingTopBanner) return <Loader isLoading={isLoadingTopBanner} />;
    if (!topBanner) return null;

    const getImageUrl = () => {
        if (width < tabletBreakpoint) return topBanner.mobile_image_url;
        if (width < desktopBreakpoint) return topBanner.tablet_image_url;
        return topBanner.desktop_image_url;
    };

    return (
        <div className="top-banner__wrapper">
            {topBanner.enable_trailer && (
                <TrailerButton
                    extraClass="trailer-button"
                    type="youtube"
                    key={topBanner.trailer_url}
                    trailerLink={topBanner.trailer_url}
                >
                    <PlayIcon className="trailer-button__svg" />
                    <span className="trailer-button__button-text">Official Trailer</span>
                </TrailerButton>
            )}
            <a
                className="top-banner__link"
                key={topBanner.id}
                href={topBanner.feature_url}
                target="_blank"
                rel="noreferrer"
            >
                <div className="top-banner__container">
                    <picture>
                        <source media="(min-width: 768px)" srcSet={getImageUrl()} />
                        <img
                            alt={topBanner.description || "Top banner image"}
                            src={getImageUrl()}
                            className="top-banner__image" />
                    </picture>
                </div>
            </a>
        </div>
    );
};

export default TopBanner;
